import { combineReducers } from "redux";
import auth from "./auth.js";
import navigation from "./navigation.js";
// import register from "./register.js";
import offers from "./offer.js";
import bids from "./bid.js";
import cdgLoadRequests from "./cdg_load_requests.js";
import ebtDrsConsumers from "./ebt_drs_consumers.js";
import ebtRetailConsumers from "./ebt_retail_consumers.js";
import ebtLogs from "./ebt_logs.js";
import units from "./unit.js";
import groups from "./group.js";
import buildings from "./building.js";
import facilities from "./facility.js";
import messages from "./maintenance.js";
import users from "./usersReducers";
import settings from "./settings.js";
import { connectRouter } from "connected-react-router";

const reducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    auth,
    navigation,
    offers,
    bids,
    cdgLoadRequests,
    ebtDrsConsumers,
    ebtRetailConsumers,
    ebtLogs,
    users,
    units,
    groups,
    buildings,
    facilities,
    messages,
    settings,
  });
export default reducer;
